"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkConnection = void 0;
const http_1 = require("../utils/http");
/**
 * Ping the base bee URL. If connection was not successful throw error
 *
 * @param requestOptions Options for making requests
 */
async function checkConnection(requestOptions) {
    await (0, http_1.http)(requestOptions, {
        url: '',
    });
}
exports.checkConnection = checkConnection;
